import { EmailType } from "../../../../../constants";
import { useSteps } from "../../../../../hook";

export const useAFLSteps = () => {
  return useSteps({
    approved: EmailType.AFLA,
    rejected: EmailType.AFLR,
    completed: EmailType.AFLF,
  });
};
